module.exports = __webpack_public_path__ + "assets/img/systemExternalUser.cd57c075.svg";